var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.27,
    height: 61.672,
    viewBox: "0 0 98.27 61.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 -0.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59503",
    "data-name": "Group 59503",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M0,59.836H59.446V.164H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-2",
    d: "M59.447,57.44v2.4H57.06",
    fill: "none",
    stroke: "#b8b8b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-3",
    x1: 40.123,
    transform: "translate(7.237 59.837)",
    fill: "none",
    stroke: "#b8b8b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4.805 8.809"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-4",
    d: "M2.387,59.837H0v-2.4",
    fill: "none",
    stroke: "#ababab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-6",
    y1: 40.275,
    transform: "translate(0 7.428)",
    fill: "none",
    stroke: "#ababab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4.805 8.809"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-8",
    d: "M0,2.56V.164H2.387",
    fill: "none",
    stroke: "#ababab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-10",
    x2: 40.123,
    transform: "translate(12.087 0.164)",
    fill: "none",
    stroke: "#ababab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4.805 8.809"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-12",
    d: "M57.06.164h2.387v2.4",
    fill: "none",
    stroke: "#ababab",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-15",
    y2: 40.275,
    transform: "translate(59.447 12.297)",
    fill: "none",
    stroke: "#b8b8b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4.805 8.809"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(20.08 7.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M24.1,1.57,29.51,12.581a1.742,1.742,0,0,0,1.312.957L42.927,15.3a1.749,1.749,0,0,1,.965,2.981l-8.76,8.572a1.752,1.752,0,0,0-.5,1.547l2.068,12.1a1.742,1.742,0,0,1-2.526,1.843L23.345,36.634a1.74,1.74,0,0,0-1.621,0L10.9,42.348A1.743,1.743,0,0,1,8.37,40.505l2.068-12.1a1.752,1.752,0,0,0-.5-1.547l-8.76-8.572A1.75,1.75,0,0,1,2.143,15.3l12.106-1.765a1.742,1.742,0,0,0,1.311-.957L20.973,1.57a1.739,1.739,0,0,1,3.123,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M24.1,1.57,29.51,12.581a1.742,1.742,0,0,0,1.312.957L42.927,15.3a1.749,1.749,0,0,1,.965,2.981l-8.76,8.572a1.752,1.752,0,0,0-.5,1.547l2.068,12.1a1.742,1.742,0,0,1-2.526,1.843L23.345,36.634a1.74,1.74,0,0,0-1.621,0L10.9,42.348A1.743,1.743,0,0,1,8.37,40.505l2.068-12.1a1.752,1.752,0,0,0-.5-1.547l-8.76-8.572A1.75,1.75,0,0,1,2.143,15.3l12.106-1.765a1.742,1.742,0,0,0,1.311-.957L20.973,1.57a1.739,1.739,0,0,1,3.123,0",
    fill: "#0bd194",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M49.752,24.764,32.1,19.892a1.351,1.351,0,0,0-1.557,1.563l4.855,17.722a1.346,1.346,0,0,0,2.282.728l2.593-2.6a1.344,1.344,0,0,1,1.906,0l7.36,7.387a1.344,1.344,0,0,0,1.906,0l3.8-3.818a1.355,1.355,0,0,0,0-1.913l-7.358-7.387a1.356,1.356,0,0,1,0-1.914l2.592-2.6a1.355,1.355,0,0,0-.725-2.291"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M49.752,24.764,32.1,19.892a1.351,1.351,0,0,0-1.557,1.563l4.855,17.722a1.346,1.346,0,0,0,2.282.728l2.593-2.6a1.344,1.344,0,0,1,1.906,0l7.36,7.387a1.344,1.344,0,0,0,1.906,0l3.8-3.818a1.355,1.355,0,0,0,0-1.913l-7.358-7.387a1.356,1.356,0,0,1,0-1.914l2.592-2.6a1.355,1.355,0,0,0-.725-2.291",
    fill: "#fff",
    stroke: "#d5d5d5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(50.998 19.52)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Fill-25",
    x2: 19.349,
    transform: "translate(6.842 1.317)",
    fill: "#ebfff8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-27",
    x2: 19.349,
    transform: "translate(0.842 0.317)",
    fill: "none",
    stroke: "#c5c5c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(56.2 28.257)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Fill-29",
    x2: 5.034,
    transform: "translate(3.842 0.317)",
    fill: "#ebfff8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-31",
    x2: 5.034,
    transform: "translate(0.842 0.317)",
    fill: "none",
    stroke: "#c5c5c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(47.2 11.783)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Fill-33",
    x2: 8.338,
    transform: "translate(0.842 0.317)",
    fill: "#ebfff8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-35",
    x2: 8.338,
    transform: "translate(0.842 0.317)",
    fill: "none",
    stroke: "#c5c5c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDrop);
export default __webpack_public_path__ + "static/media/star-drop.d6fc5e885024858c4ffae757788b16f1.svg";
export { ForwardRef as ReactComponent };